export default "__VITE_ASSET__CYjI_Oqx__"